var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    className: "social-x",
    viewBox: "0 0 1200 1227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 600,
    r: 600,
    className: "social-circle",
    style: {
      fill: "transparent"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M657.082 566.392 880.445 306.75h-52.93L633.568 532.193 478.664 306.75H300l234.246 340.91L300 919.935h52.933l204.813-238.076 163.59 238.076H900L657.068 566.392h.014Zm-72.5 84.272-23.733-33.947-188.844-270.12h81.303l152.398 217.995 23.734 33.947L827.54 881.9h-81.302L584.582 650.677v-.013Z",
    className: "social-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.ea2fc74104cab79f8650364a00dac670.svg";
export { ForwardRef as ReactComponent };